import React, { ReactNode } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "moment/locale/hu";
import {
  MyLeaveCalendarEventArrow,
  MyLeaveCalendarEventTooltip,
} from "my-leave/components";

interface MyLeaveCalendarMonthEventWrapperProps {
  date: Date;
  event: any; // TODO: replace 'any' with the actual event type
  continuesPrior?: boolean;
  continuesAfter?: boolean;
  slotStart: Date;
  slotEnd: Date;
  children?: ReactNode;
}

export const MyLeaveCalendarMonthEventWrapper: React.FC<
  MyLeaveCalendarMonthEventWrapperProps
> = (props) => {
  const theme = useTheme();
  const {
    event,
    continuesPrior,
    continuesAfter,
    children,
  } = props;

  const showPrior = continuesPrior;

  const showAfter = continuesAfter;

  return (
    <Tooltip
      arrow
      title={<MyLeaveCalendarEventTooltip event={event} />}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: theme.palette.darkBase.main,
            borderRadius: "8px",
          },
        },
        arrow: {
          sx: {
            color: theme.palette.darkBase.main,
          },
        },
      }}
    >
      <div
        className="custom-event-wrapper"
        style={{ display: "flex", flexDirection: "row" }}
      >
        {showPrior && (
          <MyLeaveCalendarEventArrow event={event} continues="prior" />
        )}
        {children}
        {showAfter && (
          <MyLeaveCalendarEventArrow event={event} continues="after" />
        )}
      </div>
    </Tooltip>
  );
};

export default MyLeaveCalendarMonthEventWrapper;
